module.exports = __webpack_public_path__ + "static/media/loginActive.27efac6b.svg";